import CustomModal from '../../../../components/Modal/CustomModal';
import {
    IconAvatarTable,
    IconClockTable,
    IconDeskOfficeTable,
    IconMarkerTable,
    IconScheduleTable,
    PeopleTalking,
    StarCalendarTitle,
} from '../../../../components/buttons/IconButtons';
import CustomCard from '../../../../components/CustomCard';
import CustomUserChip from './../../../../components/CustomUserChip';
import { status } from '../../../../enums/statusEnum';
import { chipStatusClassColor } from '../../../../enums/statusColorEnum';
import CustomGenericTittleIconDataChip from './../../../../components/CustomGenericTittleIconDataChip';
import {errorMsg, getDateFormat, getTimeFormat} from '../../../../Apis/functions';
import React, {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {GetInvitationById} from "../../../../reduxToolkit/Invitation/InvitationApi";
/**
 * @Author: Susana García Rodríguez
 * @JobTitle: Frontend - IBL
 * @Email: sgarcia@ibl.mx
 */
const UserDetails = (props) => {
    const { show, onHide, id, t } = props;
    const dispatch = useDispatch();
    const [invitation, setInvitation] = useState(null);

    useEffect(() => {
        if (id) dispatch(GetInvitationById(id)).then(({ payload: { data: { data, success, code }}}) => {
            if(success) setInvitation(data?.invitation)
            else errorMsg(code)
        });
    }, [id]);

    return (
        <CustomModal
            show={show}
            onHide={onHide}
            size='lg'
            buttonConfirm='confirm'
            cancelButton={false}
            confirmButton={false}
            topLeftHeader={
                <div className={'d-flex align-items-center pb-3'}>
                    <StarCalendarTitle />
                    <p className={'fs-modal-title font-color-general-950 ibl-font-w-600 ml-2'}>
                        {t('invitation_by')} {`${invitation?.hostName} ${invitation?.hostLastName} ${invitation?.hostSecondLastName || ''}`}
                    </p>
                </div>
            }
            classNameBody="pt-2"
        >
            <>
                <CustomCard classes={'w-100'} classCard={'card-border-8px'} classContent={'p-0 m-0'}>
                    <PeopleTalking className={'w-100'} />
                    <div className={'row'}>
                        <div className={'col-12 my-4'}>
                            <div className={'d-flex justify-content-between align-items-center'}>
                                <div className={'d-flex align-items-center'}>
                                    <IconAvatarTable />
                                    <p className={'font-color-general-950 fs-14px ml-2'}>{invitation?.visitorFullName}</p>
                                </div>
                                <div>
                                    <CustomUserChip
                                        className={`mt-0 ${chipStatusClassColor[invitation?.visitorStatusId]}`}
                                        name={t(status[invitation?.visitorStatusId])}
                                        showAvatar={false}
                                        variant='large'
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={'border-bottom-shades-300'} />
                    <div className={'row my-4'}>
                        <div className={'col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6'}>
                            <CustomGenericTittleIconDataChip title={t('date_and_time')} />

                            <div className={'mt-2'}>
                                <div className={' d-flex align-items-center'}>
                                    <IconScheduleTable className='icon-color-general-950' />
                                    <p className={'font-color-general-950 fs-14px ml-2'}>
                                        {getDateFormat(invitation?.startDate, false)}
                                        &nbsp;{t('to').toLowerCase()}&nbsp;
                                        {getDateFormat(invitation?.endDate, false)}
                                    </p>
                                </div>
                                <div className={'d-flex align-items-center'}>
                                    <IconClockTable className='icon-color-general-950' />
                                    <p className={'font-color-general-950 fs-14px ml-2'}>
                                        {getTimeFormat(invitation?.startDate)}
                                        &nbsp;{t('to').toLowerCase()}&nbsp;
                                        {getTimeFormat(invitation?.endDate)}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className={'col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6'}>
                            <CustomGenericTittleIconDataChip title={t('access_zone')} />
                            <div className={'mt-2'}>
                                {invitation?.rootFatherZoneName &&
                                <div className={"d-flex"}>
                                    <IconMarkerTable className={"mr-8px mb-1"} />
                                    <p className={"font-color-general-950 fs-14px ml-2"}>{invitation?.rootFatherZoneName}</p>
                                </div>
                                }

                                <div className={"d-flex"}>
                                    {invitation?.rootFatherZoneName ? <IconDeskOfficeTable className={"mr-8px mb-1"} /> : <IconMarkerTable className={"mr-8px mb-1"} />}
                                    <p className={"font-color-general-950 fs-14px ml-2"}>{invitation?.zoneName}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </CustomCard>
            </>
        </CustomModal>
    );
};

export default UserDetails;
